import { MutationTree } from 'vuex';

// mutations
export const mutations: MutationTree<any> = {
  SetId: (state, payload: string) => {
    state.id = payload;
  },
  SetUser: (state, payload: string) => {
    state.user = payload;
  },
  SetIsAdmin: (state, payload: boolean) => {
    state.isadmin = payload;
  },
  SetUsername: (state, payload: string) => {
    state.username = payload;
  },
  SetRoleName: (state, payload: string) => {
    state.rolename = payload;
  },
  SetCompanyName: (state, payload: string) => {
    state.companyname = payload;
  },
  SetPartyOrgName: (state, payload: string) => {
    state.partyorgname = payload;
  },
  SetRoleId: (state, payload: string) => {
    state.roleid = payload;
  },
  SetRoleInfo: (state, payload: any) => {
    state.roleInfo = payload;
  },
  
  clear: (state) => {
    state.init = true;
    state.id = "";
    state.username = "";
    state.companyname = "";
    state.partyorgname = "";
    state.isadmin = false;
    state.rolename = "";
    state.roleid = "";
    state.roleInfo = {}

  },
};
